import {h, Fragment} from "preact"
import { SerpElement, AutocompleteElement, useCurrencyFormatting } from "@nosto/preact";
import { productImagePlaceholder } from "../../helpers";
import { getProductHandle } from "../../utils"
import { 
    PriceV2 as Price, 
    BadgesV2 as Badges,
    FloatingButtonsV2 as FloatingButtons
} from "../elements";
import { useState, useEffect } from "preact/hooks";
import { useCustomConfig } from "../../hooks/useCustomConfig"


const ProductCard = ({ 
    product, 
    lid, 
    productHandle,
    enableBadges = false,
    enableQuickView = false,
    enablePromos = false
}) => {

    const { customConfig } = useCustomConfig();
    const { cards: cardsConfig } = customConfig
    const [primaryImage, setPrimaryImage] = useState(product.imageUrl || productImagePlaceholder);

    return (
        <div className={`product-card common-card trigger-floating-buttons text-left ${cardsConfig?.classColor || ""}`}>
            <div className="image-container ease-animation">
                <div className="img-wrap mode-hover">
                    <img
                        className="img main"
                        src={primaryImage}
                        alt={product.name || "Product image"}
                        width="600"
                        height="400"
                        loading="lazy"
                        onError={(e) => (e.target.src = productImagePlaceholder)}
                    />
                    { product.alternateImageUrls && product.alternateImageUrls.length > 0 &&
                        <img
                            className="img hover-img ease-animation-slow"
                            src={product.alternateImageUrls[0]}
                            alt={product.name || "Product image"}
                            width="600"
                            height="400"
                            loading="lazy"
                            onError={(e) => (e.target.src = productImagePlaceholder)}
                        />
                    }
                </div>
                {enableBadges && <Badges product={product} />}
                {enableQuickView && cardsConfig.showQuickView && <FloatingButtons product={product} productHandle={productHandle} />}
            </div>
            
            <div className="info">
                <div className="info-inner">
                    <a href={product.url} className="flex-1 product-card-url no-highlight-hover" tabindex="0">
                        <span className="title">{product.name}</span>
                    </a>
                    <Price product={product} enablePromos={enablePromos} />
                </div>
            </div>

        </div>
    )
}

 
export default function Product({ 
    product, 
    lid,
    type = "plp"
}) {

    const productHandle = getProductHandle(product.url)

    const options = type == "plp" ? {
        enableBadges: true,
        enableQuickView: true,
        enablePromos: true
    } : {
        enableBadges: false,
        enableQuickView: false,
        enablePromos: false
    }

    return (
        type == "plp" ? 
            <SerpElement
                as="div"
                hit={product}
                data-url={product.url}
                data-product-id={product.productId}
                data-product-handle={productHandle} 
                className="grid-item" 
            >
                <ProductCard 
                    product={product} 
                    lid={lid} 
                    productHandle={productHandle}
                    {... options}
                />
            </SerpElement>
        : 
            <AutocompleteElement 
                as="div"
                hit={product}
                data-url={product.url}
                data-product-id={product.productId}
                data-product-handle={productHandle} 
                className="grid-item" 
            >
                <ProductCard 
                    product={product} 
                    lid={lid} 
                    productHandle={productHandle}
                    {... options}
                />
            </AutocompleteElement>
    );
}
